import { schema } from 'normalizr';
import { CALL_API } from '../middleware/api';

// ACTIONS
export const MASTER_LOGS_FETCH_REQUEST = 'masterLogs/MASTER_LOGS_FETCH_REQUEST';
export const MASTER_LOGS_FETCH_SUCCESS =
  'masterLogs/MASTER_LOGS_FETCHED_SUCCESS';
export const MASTER_LOGS_FETCH_ERROR = 'masterLogs/MASTER_LOGS_FETCHED_ERROR';

// REDUCER
export default function reducer(
  state = {
    entities: null,
    result: [],
    current: null,
    fetching: false,
    fetched: false,
    error: null,
  },
  action
) {
  switch (action.type) {
    case MASTER_LOGS_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case MASTER_LOGS_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        entities: action.payload.entities.masterLogs,
        result: action.payload.result,
      };

    case MASTER_LOGS_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// Schemas
export const masterLogSchema = new schema.Entity('masterLogs');

// Operations
export function fetchMasterLogs(params) {
  return {
    [CALL_API]: {
      types: [
        MASTER_LOGS_FETCH_REQUEST,
        MASTER_LOGS_FETCH_SUCCESS,
        MASTER_LOGS_FETCH_ERROR,
      ],
      promise: (httpClient) => httpClient.post('/masterLog', params),
      schema: { data: [masterLogSchema] },
    },
  };
}
